import { Directive, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';

import { ISnPlayer } from '../interfaces';
import { SnPlayerGroupReference } from '../references';

@Directive({ selector: '[snPlayerGroup]' })
export class SnPlayerGroupDirective implements OnInit, OnDestroy {
  @Input('snPlayerGroup') public name: string;
  @Output('snPlayerGroupInit') public readonly init = new EventEmitter<SnPlayerGroupReference>();

  public readonly items: Set<ISnPlayer>;
  public readonly reference: SnPlayerGroupReference;

  constructor() {
    this.items = new Set();
    this.reference = new SnPlayerGroupReference(this.items);
  }

  public ngOnInit(): void {
    this.init.emit(this.reference);
  }

  public ngOnDestroy(): void {
    this.items.clear();
    this.init.complete();
  }
}
